import type { TenantConfig } from '@/types/TenantConfig'

const lightGrey = '#fafafa'
const pink = '#e3008c'
const black = '#000000'
const white = '#ffffff'
const grey = '#7e7e82'

export const nml: TenantConfig = {
  logo: 'assets/nml/static/logo.png',
  teaserImageSize: {
    width: 320,
  },
  themeOptions: {
    logoHeight: '65px',
    headerHeight: '105px',
    pageBackgroundColor: lightGrey,
    primaryColor: pink,
    footerTextColor: grey,
    dialog: {
      headerBackground: black,
      headerTextColor: white,
      headerIconColor: white,
    },
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/nml/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-160px',
        mobile: '-120px',
      },
    },
  },
  i18nOverrides: {
    en: {
      checkoutRoute: {
        title: 'Payment Information',
      },
    },
  },
}
